// components
import SvgIconStyle from '../../../components/SvgIconStyle';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  wallet: getIcon('ic_wallet'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  banking: getIcon('ic_banking'),
  invoice: getIcon('ic_invoice'),
  clock: getIcon('ic_clock'),
  creditCard: getIcon('ic_credit_card'),
  fileText: getIcon('ic_file_text'),
  setting: getIcon('ic_setting'),
  briefcase: getIcon('ic_briefcase'),
  terminal: getIcon('ic_globe'),
  master: getIcon('ic_master'),
  discount: getIcon('ic_discount'),
  ticket: getIcon('ic_ticket'),
  gift: getIcon('ic_gift'),
  usd: getIcon('ic_currency'),
};

const navConfig = [
  {
    subheader: 'مدیریت',
    items: [
      {
        title: 'آمار',
        path: PATH_DASHBOARD.statistic.root,
        icon: ICONS.analytics,
      },
      {
        title: 'کاربران',
        icon: ICONS.user,
        children: [
          { title: 'لیست کاربران', path: PATH_DASHBOARD.user.root },
          { title: 'ثبت کاربر جدید', path: PATH_DASHBOARD.user.new },
        ],
      },
      {
        title: 'کدهای Redeem',
        path: PATH_DASHBOARD.redeemCode.root,
        icon: ICONS.gift,
      },
      {
        title: 'شارژ اکانت Aegpay',
        icon: ICONS.wallet,
        path: PATH_DASHBOARD.topup.root,
      },
      {
        title: 'مسترکارت/ویزا',
        icon: ICONS.master,
        children: [
          { title: 'لیست کارت‌ها', path: PATH_DASHBOARD.bankCard.root },
          { title: 'ارائه دهندگان کارت', path: PATH_DASHBOARD.bankCard.productions },
        ],
      },
      {
        title: 'درخواست‌ها',
        icon: ICONS.analytics,
        children: [
          {
            title: 'کارت آفلاین',
            path: PATH_DASHBOARD.cardRequests.root,
          },
          {
            title: 'KYC',
            path: PATH_DASHBOARD.userKycForm.root,
          },
          {
            title: ' تایید مدارک',
            path: PATH_DASHBOARD.userRequest.root,
          },
          {
            title: ' ثبت آدرس',
            path: PATH_DASHBOARD.addressRequests.root,
          },
        ],
      },
      {
        title: 'مشتریان B2B',
        icon: ICONS.user,
        children: [
          { title: 'لیست مشتریان B2B', path: PATH_DASHBOARD.partner.root },
          { title: 'ثبت مشتری B2B جدید', path: PATH_DASHBOARD.partner.new },
        ],
      },
      {
        title: 'کیف پول کاربران',
        path: PATH_DASHBOARD.wallet.root,
        icon: ICONS.creditCard,
      },
      {
        title: 'تاریخچه کیف پول کاربران',
        path: PATH_DASHBOARD.walletHistory.root,
        icon: ICONS.fileText,
      },

      {
        title: 'کوپن‌های تخفیف',
        icon: ICONS.discount,
        children: [
          { title: 'لیست کوپن‌های تخفیف', path: PATH_DASHBOARD.discountCoupon.root },
          { title: 'ثبت کوپن تخفیف جدید', path: PATH_DASHBOARD.discountCoupon.new },
        ],
      },
      {
        title: 'تیکت‌ها',
        path: PATH_DASHBOARD.ticket.root,
        icon: ICONS.ticket,
      },
      {
        title: 'تنظیمات',
        icon: ICONS.setting,
        children: [
          { title: 'تنظیمات عمومی', path: PATH_DASHBOARD.setting.root },
          {
            title: 'تبدیل ارز',
            path: PATH_DASHBOARD.exchange.root,
            icon: ICONS.wallet,
          },
          {
            title: 'درگاه‌های پرداخت',
            path: PATH_DASHBOARD.gateway.root,
            icon: ICONS.banking,
          },
          {
            title: 'ترمینال‌ها',
            path: PATH_DASHBOARD.terminal.root,
            icon: ICONS.terminal,
          },
          {
            title: 'ساعت تحویل',
            path: PATH_DASHBOARD.delivery.root,
            icon: ICONS.clock,
          },
          {
            title: 'پلن ها',
            path: PATH_DASHBOARD.plans.root,
            icon: ICONS.clock,
          },
        ],
      },
    ],
  },
  {
    subheader: 'به زودی',
    items: [
      {
        title: 'برداشت وجه',
        path: PATH_DASHBOARD.withdrawal.root,
        icon: ICONS.creditCard,
      },
      {
        title: 'سفارشات',
        path: PATH_DASHBOARD.order.root,
        icon: ICONS.ecommerce,
      },
      {
        title: 'ترمینال‌ها',
        path: PATH_DASHBOARD.terminal.root,
        icon: ICONS.terminal,
      },
      {
        title: 'ساعت تحویل',
        path: PATH_DASHBOARD.delivery.root,
        icon: ICONS.clock,
      },
      {
        title: 'تراکنش‌ها',
        path: PATH_DASHBOARD.payment.root,
        icon: ICONS.fileText,
      },
    ],
  },
];

export default navConfig;
